declare global {
  interface Window {
    __ENV__?: {
      REACT_APP_API_URL?: string;
    };
  }
}

export const getRuntimeConfigValue = (key: keyof NonNullable<Window['__ENV__']>) =>
  (window.__ENV__?.[key] || '').trim();

export const getConfiguredApiUrl = () =>
  getRuntimeConfigValue('REACT_APP_API_URL') || (process.env.REACT_APP_API_URL || '').trim();

export const getUploadsBaseUrl = () =>
  (getConfiguredApiUrl() || 'https://localhost:7195/api').replace(/\/api\/?$/, '');

export {};
